import React, { useEffect, useState } from 'react';
import { Provider } from 'mobx-react';
import { ReactKeycloakProvider } from '@react-keycloak/web';

import { AppTheme } from 'components/AppTheme';
import FullscreenLoader from 'components/Loading/Fullscreen';
import keycloak from 'helpers/keycloak';

import { APP_CONFIG } from 'appConfig';
import { API_ALIVE } from 'api/endpoints';
import { RootStore } from 'stores/rootStore';
import AppWithAuth from './App';

import BackendDown from 'pages/Error/BackendDown';

const rootStore = new RootStore(keycloak);

const App: React.FC = () => {
  const [health, setHealth] = useState<boolean | undefined>(undefined);
  useEffect(() => {
    (async () => {
        try {
          const response = await fetch(`${APP_CONFIG.apiUrl}${API_ALIVE}`);
          setHealth(response.status === 204);
        } catch {
          setHealth(false);
        }
    })();
  }, []);


  return health ? (
    <ReactKeycloakProvider
      authClient={keycloak}
      initOptions={{ checkLoginIframe: false }}
      LoadingComponent={<FullscreenLoader />}
    >
      <Provider {...rootStore.stores} rootStore={rootStore}>
        <AppTheme>
          <AppWithAuth />
        </AppTheme>
      </Provider>
    </ReactKeycloakProvider>
  ) : health === false ? (
    <Provider {...rootStore.stores} rootStore={rootStore}>
      <AppTheme>
        <BackendDown />
      </AppTheme>
    </Provider>
  ) : (
    <FullscreenLoader />
  );
};

export default App;
